const index = {
  pageView: path => {
    if (!window.hj) return console.info('HotJar: virtual page view:', path) // eslint-disable-line
    return window.hj('vpv', path)
  },
}

export default index
